import create from 'zustand'
import { persist } from 'zustand/middleware'
import { Auth, Scope } from './types/authorized.types'

type State = {
  auth: Auth | undefined
  setAuth: ($auth: Auth | undefined) => void
  scope: string[] | undefined
  setScope: ($scope: any) => void
  accessToken: string | undefined
  setAccessToken: ($token: string | undefined) => void
}

export const useAuth = create(
  persist<State>(
    (set) => ({
      auth: {
        user: undefined,
        isLoggedIn: false,
        authorized: {
          accessToken: undefined,
          refreshToken: undefined,
          expiresIn: undefined,
          scope: undefined,
        },
      },
      setAuth: ($auth: Auth | undefined) => {
        set({ auth: $auth })
      },
      scope: undefined,
      setScope: ($scope) => {
        set({ scope: $scope })
      },

      accessToken: undefined,
      setAccessToken: ($token = undefined) => {
        set({ accessToken: $token })
      },
    }),
    {
      name: 'authorized',
      getStorage: () => localStorage,
    },
  ),
)
